export const REGISTRY_ACTIVATION_WELCOME = 'REGISTRY_ACTIVATION_WELCOME';
export const REGISTRY_ACTIVATION_ORG = 'REGISTRY_ACTIVATION_ORG';
export const REGISTRY_ACTIVATION_MEMBERS = 'REGISTRY_ACTIVATION_MEMBERS';
export const REGISTRY_ACTIVATION_REGISTRY_EXISTS = 'REGISTRY_ACTIVATION_REGISTRY_EXISTS';
export const REGISTRY_ACTIVATION_WEBINAR = 'REGISTRY_ACTIVATION_WEBINAR';

export const ALL_SCREENS = [
  REGISTRY_ACTIVATION_WELCOME,
  REGISTRY_ACTIVATION_ORG,
  REGISTRY_ACTIVATION_MEMBERS,
  REGISTRY_ACTIVATION_REGISTRY_EXISTS,
  REGISTRY_ACTIVATION_WEBINAR,
] as const;

export type RegistryActivationFlowScreen = (typeof ALL_SCREENS)[number];
